// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectReplaceAlertMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_REPLACE_ALERT_MESSAGE)

    this.InstrumentTradableID = -1;
    this.RouteId = null;

    this.AlertId = -1;
    this.AlertType = null;
    this.AlertCondition = null;
    this.AlertValue = null;
    this.AlertImportance = null;
    this.Date = null;
    this.AlertAfterExecute = null;
    this.AlertAction = null;
    this.AlertNotification = null;
    this.Text = null;
}

DirectReplaceAlertMessage.prototype = Object.create(DirectMessageBase.prototype)